export default {
  TITLE: '404 Page Not Found',
  DESCRIPTION:
    'アクセスしようとしたページは削除されたか、\n移動した可能性があります。',
  BUTTON: {
    BACK: 'もどる',
  },
};
